<article class="store-row"
         [class.muted]="muted"
         [style.--plugin-primary]="product?.designTokens?.primaryColor || 'var(--theme-color)'"
         [style.--plugin-secondary]="product?.designTokens?.secondaryColor || 'var(--theme-color-secondary)'">

  <div class="row-main">
    <!-- Identity: icon, CATEGORY / MODE, name, the theme's colours -->
    <!-- the theme page opens in a new tab; this page (cart / order) stays -->
    <a class="identity" *ngIf="themeQuery; else plainIdentity" [routerLink]="palette ? '/palette' : '/theme'" [queryParams]="palette ? { product: product?.key } : themeQuery" target="_blank" rel="noopener" [attr.aria-label]="name + ( platformName ? ' for ' + platformName : '' ) + ( palette ? ', palette page' : ', theme page' ) + ' (opens in a new tab)'">
      <!-- the theme's icon alone: its platform is named in the middle column (owner 2026-10-12: the corner badge
           said it twice) -->
      <span class="identity-logo-wrap" *ngIf="product?.logo">
        <img class="identity-logo" [src]="product?.logo" alt="">
      </span>
      <span class="identity-text">
        <span class="identity-category" *ngIf="category">{{ category }}<ng-container *ngIf="product?.appearance"><span class="identity-dash"></span>{{ product?.appearance }}</ng-container></span>
        <span class="identity-name">{{ name }}</span>
        <span class="identity-colors" *ngIf="colors.length" aria-hidden="true">
          <span class="identity-color" *ngFor="let color of colors" [style.background-color]="color"></span>
        </span>
      </span>
    </a>
    <ng-template #plainIdentity>
      <!-- an app (2026-10-14): its icon and name, linking to the app's own page -->
      <a class="identity" *ngIf="app && appUrl; else unknownIdentity" [routerLink]="appUrl" target="_blank" rel="noopener" [attr.aria-label]="name + ( platformName ? ' for ' + platformName : '' ) + ', app page (opens in a new tab)'">
        <span class="identity-logo-wrap" *ngIf="product?.logo">
          <img class="identity-logo" [src]="product?.logo" alt="">
        </span>
        <span class="identity-text">
          <span class="identity-category" *ngIf="category">{{ category }}</span>
          <span class="identity-name">{{ name }}</span>
        </span>
      </a>
    </ng-template>
    <ng-template #unknownIdentity>
      <!-- a sku the site no longer knows: no icon to badge; the platform is still named in the middle column -->
      <div class="identity">
        <span class="identity-text">
          <span class="identity-category" *ngIf="category">{{ category }}</span>
          <span class="identity-name">{{ name }}</span>
        </span>
      </div>
    </ng-template>

    <!-- The middle column: what the page says about the line (the licence and the version), then
         "for <platform>" (owner, 2026-09-20: under the version) -->
    <div class="meta">
      <ng-content select="[cardMeta]"></ng-content>
      <span class="meta-platform" *ngIf="platformLabel">
        <img class="meta-platform-logo" *ngIf="platformLogo" [src]="platformLogo" alt="">{{ platformLabel }}
      </span>
    </div>

    <!-- The page's actions (price + quantity / download) -->
    <div class="actions">
      <ng-content select="[cardActions]"></ng-content>
    </div>
  </div>

  <!-- Under the row: the theme's tags as pills (owner, 2026-09-20: as on the You might also like cards),
       then whatever the page projects (a warning, a note) -->
  <div class="row-footer">
    <span class="row-tags" *ngIf="tags.length" aria-label="Tags">
      <span class="row-tag" *ngFor="let tag of tags">{{ tag }}</span>
    </span>
    <ng-content select="[cardFooter]"></ng-content>
  </div>
</article>
